var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box no-margin" }, [
    _c("div", { staticClass: "box-header" }, [
      _c(
        "h3",
        { staticClass: "box-title", attrs: { slot: "header" }, slot: "header" },
        [
          _c("span", {
            domProps: { textContent: _vm._s(_vm.t("register.IC_0001")) },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box-body clearfix" }, [
      _vm.data === "newIndividual"
        ? _c("div", [_c("div", [_c("new-individual")], 1)])
        : _c("div", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "large-12 columns text-center" },
                [
                  _c("process-model", {
                    attrs: {
                      models: _vm.processModel,
                      "max-stage": _vm.maxStage,
                      "current-stage": _vm.stage,
                    },
                    on: {
                      "current-stage": function (val) {
                        return (_vm.stage = val)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "keep-alive",
                  [
                    _c(_vm.stageComponents[_vm.stage], {
                      tag: "component",
                      attrs: {
                        tab: _vm.tab,
                        "ge-contractor": _vm.geContractor,
                        "ge-member-ids": _vm.geMemberIds,
                      },
                      on: {
                        "stage-change": _vm.stageChanged,
                        "ge-contractor": function ($event) {
                          _vm.geContractor = true
                        },
                        "tab-change": _vm.tabChanged,
                        "reset-tab": function ($event) {
                          _vm.tab = -1
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }